import React from 'react'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { BillingProfileTable } from '../../components/ClientBillingProfileManagement/ClientBillingProfileTable'
import { BillingProfileTabsHeader } from '../../components/BillingProfileTabsHeader'
import { BILLING_PROFILE_TAB_KEYS } from '../../constants'

const { Content } = Layout

export default function BillingProfileManagement() {
  return (
    <PageWrapper>
      <Page
        title="Billing Profile"
        maxWidth="100%"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: '/finance' },
              { title: 'Billing Profile' },
            ]}
          />
        }
      >
        <BillingProfileTabsHeader
          activeTab={BILLING_PROFILE_TAB_KEYS.COMPANIES}
        />

        <Layout style={{ backgroundColor: '#F7F9FC' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            <BillingProfileTable />
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
